const referralConfig = {
    send_tax_guide: {
        title: 'subscribe_to_get_guide',
        subtitle: 'access_essential_guidance',
        button: 'get_guide',
        switchName: 'subscribe_with',
    },
}

const getReferralText = (
    referralAction: string | undefined,
    field: keyof typeof referralConfig['send_tax_guide']
) => {
    return referralAction && referralConfig[referralAction]?.[field]
}

export const getTitle = (action?: string) =>
    getReferralText(action, 'title') ?? 'login_or_signup'

export const getSubtitle = (action?: string) =>
    getReferralText(action, 'subtitle') ?? 'sign_in_prompt'

export const getButtonName = (action?: string) =>
    getReferralText(action, 'button') ?? 'get_code'

export const getSwitchName = (action?: string) =>
    getReferralText(action, 'switchName') ?? 'verify_with'